import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // CRITICAL: returning from OAuth — AuthCallback exchanges the session_id first.
    if (window.location.hash?.includes("session_id=")) return;
    api
      .get("/auth/me")
      .then(({ data }) => {
        localStorage.setItem("cx_user", JSON.stringify(data));
        setUser(data);
      })
      .catch((e) => {
        // Field devices lose signal: a network failure must not log the engineer out.
        const cached = localStorage.getItem("cx_user");
        if (!e.response && cached) setUser(JSON.parse(cached));
        else {
          if (e.response?.data?.detail === "SESSION_EXPIRED") {
            localStorage.removeItem("cx_token");
            localStorage.removeItem("cx_user");
            window.location.replace("/login?reason=expired");
            return;
          }
          setUser(false);
        }
      });
  }, []);

  const login = async (email, password, captchaId, captchaAnswer) => {
    const { data } = await api.post("/auth/login", {
      email,
      password,
      captcha_id: captchaId || "",
      captcha_answer: captchaAnswer || "",
    });
    if (data.otp_required) return data; // Super Admin: no session until the OTP is verified.
    localStorage.setItem("cx_token", data.access_token);
    localStorage.setItem("cx_user", JSON.stringify(data));
    setUser(data);
    return data;
  };

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem("cx_token", data.access_token);
    setUser(data);
    return data;
  };

  const logout = async () => {
    try {
      await api.post("/auth/logout");
    } catch (e) {
      /* ignore */
    }
    localStorage.removeItem("cx_token");
    localStorage.removeItem("cx_user");
    setUser(false);
  };

  return <AuthContext.Provider value={{ user, login, register, logout, setSession: setUser }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
